import styled, { keyframes } from 'styled-components'

const LineH = keyframes`
  0%{
		width: 0%;
	}
	100%{
    width: 95%;
    opacity: 0;
  }
 `

export const Light = styled.div`
  position: relative;
  width: 100%;
`

export const Light1 = styled.div`
  position: absolute;
  left: 0;
  height: 5px;
  background: #00aa2b;
  animation: ${LineH} 4s 5s infinite linear;
`

export const Light2 = styled.div`
  position: absolute;
  left: 0;
  top: 30px;
  height: 5px;
  background: var(--secondary);
  animation: ${LineH} 5s 0.5s infinite linear;
`

export const Light3 = styled.div`
  position: absolute;
  left: 0;
  top: 70px;
  height: 5px;
  background: #ff557f;
  animation: ${LineH} 5s 2s infinite linear;
`

export const Light4 = styled.div`
  position: absolute;
  right: 0;
  top: 65px;
  height: 5px;
  background: #d50055;
  animation: ${LineH} 5s 1s infinite linear;
`

export const Light5 = styled.div`
  position: absolute;
  left: 0;
  top: 80px;
  height: 5px;
  background: #aa8000;
  animation: ${LineH} 5s 4s infinite linear;
`

export const Light6 = styled.div`
  position: absolute;
  right: 0;
  top: 90px;
  height: 5px;
  background: #aaff00;
  animation: ${LineH} 4s 1s infinite linear;
`

export const Light7 = styled.div`
  position: absolute;
  right: 0;
  top: 190px;
  height: 10px;
  background: #d50055;
  animation: ${LineH} 4s 0s infinite linear;
`

export const Light8 = styled.div`
  position: absolute;
  left: 0;
  top: 220px;
  height: 10px;
  background: #00ffff;
  animation: ${LineH} 4s 1.5s infinite linear;
`

export const Light9 = styled.div`
  position: absolute;
  left: 0;
  top: 250px;
  height: 10px;
  background: #2b002b;
  animation: ${LineH} 5s 2s infinite linear;
`

export const Light10 = styled.div`
  position: absolute;
  right: 0;
  top: 280px;
  height: 10px;
  background: #005580;
  animation: ${LineH} 4s 3s infinite linear;
`

export const Light11 = styled.div`
  position: absolute;
  right: 0;
  top: 310px;
  height: 10px;
  background: #ff557f;
  animation: ${LineH} 4s 1s infinite linear;
`

export const Light12 = styled.div`
  position: absolute;
  right: 0;
  top: 340px;
  height: 10px;
  background: #85b085;
  animation: ${LineH} 6s 1s infinite linear;
`
